var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M498 392L498 420",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 498.5,
    cy: 387.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M493.987 387.19C493.987 383.283 497.288 380.117 501.358 380.117C501.943 380.117 502.511 380.184 503.056 380.308C501.742 379.48 500.187 379 498.519 379C493.814 379 490 382.806 490 387.5C490 392.194 493.814 396 498.519 396C500.814 396 502.895 395.093 504.427 393.62C503.492 394.032 502.454 394.263 501.358 394.263C497.288 394.263 493.987 391.096 493.987 387.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M507.402 386.6L507.37 384.146L505.535 385.719L503.304 385.056L504.112 387.337L502.765 389.381L505.1 389.218L506.499 391.144L507.133 388.763L509.345 387.909L507.402 386.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch4);
export default __webpack_public_path__ + "static/media/church_4.a8b458d1a15111ead8b5f9d2f4060a33.svg";
export { ForwardRef as ReactComponent };